var collapsible_list_pair_rtlignore_default = {
  "container": "T5Rcf",
  "title": "_3F0K4",
  "viewerContainer": "egraH",
  "titleContainer": "cyQpI",
  "expandIcon": "F0UIq",
  "dndIcon": "XcyFd",
  "RTL": "f96Kz",
  "LTR": "eggSv",
  "itemContainer": "uES4p",
  "itemContainerViewer": "Ma93I",
  "mouseDown": "_8niKz",
  "innerEditor": "h-9Pv",
  "item": "K9tNo",
  "floatingAddPluginMenuWrapper": "_1-Jmc",
  "childrenHidden": "_0eYmG"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
